import { View } from "react-native";
import { Text } from "react-native-paper";

const Sandbox = () => (
	<View>
		<Text>sandbox</Text>
	</View>
);

export default Sandbox;
